<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T0IkRd/tc-custom/9781467434133.jpg?1731411640389" alt="This image is the cover for the book Religious Liberty, Vol. 1, Emory University Studies in Law and Religion (EUSLR)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Religious Liberty, Vol. 1, Emory University Studies in Law and Religion (EUSLR)
      </h1>
      <p class="bookDescription body article font2">
        <p>The Collected Works on Religious Liberty comprehensively collects the scholarship, advocacy, and explanatory writings of leading scholar and lawyer Douglas Laycock, illuminating every major religious liberty issue from both theoretical and practical perspectives.  / This first volume gives the big picture of religious liberty in the United States. It fits a vast range of disparate disputes into a coherent pattern, from public school prayers to private school vouchers to regulation of churches and believers. Laycock clearly and carefully explains what the law is and argues for what the law should be. He also reviews the history of Western religious liberty from the American founding to Protestant-Catholic conflict in the nineteenth century, using this history to cast light on the meaning of our constitutional guarantees.  / Collected Works on Religious Liberty is unique in the depth and range of its coverage. Laycock helpfully includes both scholarly articles and key legal documents, and unlike many legal scholars, explains them clearly and succinctly. All the while, he maintains a centrist perspective, presenting all sides — believers and nonbelievers alike — fairly.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Douglas Laycock
      </h2>
      
      <p class="authorDescription body article"> &#160; <B>Douglas Laycock</B>&#160;is Robert E. Scott Distinguished Professor of Law and professor of religious studies at the University of Virginia. In addition to his work as a lawyer, he has written for the&#160;<I>New York Times</I>, the&#160;<I>Washington Post</I>, and numerous other publications. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b5fdbbe